/**
 * Represents the document type
 */
const DocumentTypeEnum = {
  PaymentNotice: 1,
  ViolationReport: 2,
  GenericLetter: 3,
  F24: 4,
};

export default DocumentTypeEnum;
